/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsUserControllerFindCountsQueryResponse,
  TelegramProductsUserControllerFindCounts401,
} from '../../types/TelegramProductsUserControllerFindCounts.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramProductsUserFindCounts } from '../../methods/telegramProductsUserFindCounts.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramProductsUserFindCountsQueryKey = () => [{ url: '/api/user/telegram/products/counts' }] as const;

export type TelegramProductsUserFindCountsQueryKey = ReturnType<typeof telegramProductsUserFindCountsQueryKey>;

export function telegramProductsUserFindCountsQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramProductsUserFindCountsQueryKey();
  return queryOptions<
    TelegramProductsUserControllerFindCountsQueryResponse,
    ResponseErrorConfig<TelegramProductsUserControllerFindCounts401>,
    TelegramProductsUserControllerFindCountsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramProductsUserFindCounts(config);
    },
  });
}

/**
 * {@link /api/user/telegram/products/counts}
 */
export function useTelegramProductsUserFindCounts<
  TData = TelegramProductsUserControllerFindCountsQueryResponse,
  TQueryData = TelegramProductsUserControllerFindCountsQueryResponse,
  TQueryKey extends QueryKey = TelegramProductsUserFindCountsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramProductsUserControllerFindCountsQueryResponse,
        ResponseErrorConfig<TelegramProductsUserControllerFindCounts401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramProductsUserFindCountsQueryKey();

  const query = useQuery(
    {
      ...telegramProductsUserFindCountsQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramProductsUserControllerFindCounts401>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
